import {
  GOVGR_BREADCRUMBS,
  GOVGR_BREADCRUMS__LIST,
} from "../../conf/styles/BreadCrumbs";
import Segment from "./Segment";

// Segments is a list of objects.
// Each object has two keys 1) href 2) label
const GovGrBreadcrumbs = ({ segments }) => {
  return (
    <div className={GOVGR_BREADCRUMBS}>
      <ol className={GOVGR_BREADCRUMS__LIST}>
        {segments?.map((segment) => (
          <Segment
            key={segment?.label}
            label={segment.label}
            href={segment.href}
          />
        ))}
      </ol>
    </div>
  );
};

export default GovGrBreadcrumbs;
